import "../css/footer.css";
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-scroll-wrapper">
        <div className="footer-container-row">
          <div className="footer-item">
            <FaPhone className="footer-icon" />
            <a href="tel:+447475510591">07475510591</a>
          </div>

          <div className="footer-item">
            <FaEnvelope className="footer-icon" />
            <a href="mailto:info@alphacontraining.co.uk">
              info@alphacontraining.co.uk
            </a>
          </div>

          <div className="footer-item">
            <FaMapMarkerAlt className="footer-icon" />
            <span>86 High Street, West Bromwich, B70 6JW</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
